import React from "react";
import { Link } from "gatsby";
import "./styles.scss";
import MainNav from "../MainNav";
import UtilityNav from "../UtilityNav";
import Logo from "../../images/logo.svg";

function DesktopNav() {
	return (
		<header className="section section--is-dark section--is-paddingless desktop-nav">
			<div className="desktop-nav__container">
				<div className="desktop-nav__logo">
					<Link to="/">
						<img src={Logo} alt="Irish Titan" width="298px" height="55px" />
					</Link>
				</div>
				<div className="desktop-nav__nav">
					<UtilityNav />
					<MainNav />
				</div>
			</div>
		</header>
	);
};

export default DesktopNav;
